import { getPageName } from '../utils/pageName';

interface CustomWindow extends Window {
  /* eslint-disable camelcase */
  read_key: string;
  /* eslint-enable camelcase */
}

declare let window: CustomWindow;

export const getAccessKey = () => {
  const pageName = getPageName();
  const readKey = pageName === 'Search' ? 'SEARCH' : window.read_key;
  return readKey;
};
